module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "records-root container"
  }, [(_vm.$route.path === "/records") ? [_c('h1', [_vm._v("信息记录")]), _c('br'), _c('router-link', {
    staticClass: "ui button themed",
    attrs: {
      "to": "/records/meters"
    }
  }, [_vm._v("公寓水电表记录")])] : [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/records"
    }
  }, [_vm._v("< 返回")])], 1)], _c('router-view')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-123de960","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Records.vue
// module id = 439
// module chunks = 0